<section class="insured">
  <div class="insured__head">
    <div>
      <h3>Bénéficiaires</h3>
      <p>Ajoutez les personnes couvertes par votre contrat Malaika.</p>
    </div>
    <button type="button" class="insured__add" *ngIf="canAddInsured" (click)="openAddSheet()">
      <mat-icon>person_add</mat-icon>
      Ajouter
    </button>
  </div>

  <p class="insured__empty" *ngIf="!assures.length">
    Aucun bénéficiaire ajouté pour le moment.
  </p>

  <article class="insured-card" *ngFor="let assure of assures">
    <div class="insured-card__avatar" aria-hidden="true">
      <mat-icon>person</mat-icon>
    </div>
    <div class="insured-card__body">
      <div class="insured-card__grid">
        <div class="insured-card__item" *ngFor="let field of visibleCardFields(assure)">
          <span>{{ cardFieldLabel(field) }}</span>
          <strong>{{ displayValue(field, assure) }}</strong>
        </div>
      </div>
    </div>
    <div class="insured-card__actions">
      <button type="button" aria-label="Modifier" (click)="openEditSheet(assure)">
        <mat-icon>edit</mat-icon>
      </button>
      <button
        type="button"
        aria-label="Supprimer"
        *ngIf="canRemoveAssure(assure)"
        (click)="removeAssure(assure)">
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </article>

  <p class="insured__error" *ngIf="validationMessage">{{ validationMessage }}</p>
</section>

<div class="insured-sheet" *ngIf="sheetOpen && sheetForm as form" (mousedown)="onSheetBackdropMouseDown($event)">
  <div class="insured-sheet__panel" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
    <div class="insured-sheet__handle" aria-hidden="true"></div>
    <h3>{{ editingAssure ? 'Modifier le bénéficiaire' : 'Nouveau bénéficiaire' }}</h3>

    <form [formGroup]="form" (ngSubmit)="saveSheet()">
      <div
        class="insured-sheet__field"
        *ngFor="let field of bottomSheetFields"
        [class.insured-sheet__field--bank]="fieldType(field) === 'toggle'">
        <label [attr.for]="field.id" *ngIf="fieldType(field) !== 'toggle'">{{ field.label || field.name }}</label>

        <app-subscription-bank-details
          *ngIf="fieldType(field) === 'toggle'"
          [formControlName]="field.name"
          [fieldId]="field.id"
          [banks]="bankOptions">
        </app-subscription-bank-details>

        <div class="insured-sheet__select" *ngIf="isSelectField(field)">
          <select
            class="insured-sheet__input"
            [formControlName]="field.name"
            [id]="field.id"
            [compareWith]="compareSelectValues">
            <option [ngValue]="''">Choisir…</option>
            <option
              *ngFor="let opt of selectOptions(field); trackBy: trackSelectOption"
              [ngValue]="optionValue(opt)">
              {{ optionLabel(opt) }}
            </option>
          </select>
          <mat-icon class="insured-sheet__affix" aria-hidden="true">expand_more</mat-icon>
        </div>

        <input
          *ngIf="fieldType(field) === 'date'"
          class="insured-sheet__input"
          type="date"
          [formControlName]="field.name"
          [id]="field.id" />

        <input
          *ngIf="fieldType(field) === 'number' || fieldType(field) === 'numeric'"
          class="insured-sheet__input"
          type="number"
          [formControlName]="field.name"
          [id]="field.id" />

        <input
          *ngIf="!isSelectField(field) && !['date', 'number', 'numeric', 'toggle'].includes(fieldType(field))"
          class="insured-sheet__input"
          type="text"
          [formControlName]="field.name"
          [id]="field.id" />
      </div>

      <p class="insured-sheet__error" *ngIf="sheetError">{{ sheetError }}</p>

      <div class="insured-sheet__actions">
        <button type="button" class="btn btn--ghost" (click)="closeSheet()">Annuler</button>
        <button type="submit" class="btn btn--primary">Enregistrer</button>
      </div>
    </form>
  </div>
</div>

<app-confirm-modal
  [open]="!!assurePendingRemoval"
  title="Supprimer ce bénéficiaire ?"
  message="Cette action retirera le bénéficiaire de la liste. Vous pourrez en ajouter un autre ensuite."
  confirmLabel="Supprimer"
  cancelLabel="Annuler"
  icon="delete_outline"
  [destructive]="true"
  (cancelled)="cancelRemoveAssure()"
  (confirmed)="confirmRemoveAssure()">
</app-confirm-modal>
